import React from 'react'; // eslint-disable-line
import moment from 'moment';
import i18n from '../../i18n';
import placeholder from '../../assets/styles/img/img-placeholder-full-width.png';

const PreviewFeaturedSermonsItem = (props) => {
    return (
        <div className="sermons-item featured">
            <div className="sermons-item-thumbnail">
                {props.item
                && (
                    <img src={props.item.thumbnailImage
                        ? props.item.thumbnailImage : placeholder}
                    />
                )}
            </div>
            <div className="sermons-item-info">
                <h5 style={{ color: props.accentColor }}>
                    {' '}
                    {i18n.t('modules.sermons.section2.label1')}
                </h5>
                <h4 className="sermons-item-title" style={{ color: props.primaryText }}>
                    {props.item ? props.item.title : ''}
                </h4>
                <p className="sermons-timeago">
                    {props.item ? moment(props.item.date).format('MMM D') : ''}
                </p>
            </div>
        </div>
    );
};

export default PreviewFeaturedSermonsItem;
